import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../services/admin';
import { Component, OnInit } from '@angular/core';

import { Message } from 'model/modal-cms/message';
import { CMSService } from '../../../services/cms-service';
import { Reponse } from 'model/modal-cms/reponse';
declare var mdtoast: any;
import Swal from 'sweetalert2'
declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Message, bien envoyer.", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var erreu_mes_vide = mdtoast("Opération nom effectuée, contenue message vide.", { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-voire-question',
  templateUrl: './voire-question.component.html',
  styleUrls: ['./voire-question.component.scss']
})
export class VoireQuestionComponent implements OnInit {
  id: any;
  im: number = 254778
  nom: string = "ANDRIANJATO ";
  prenom: string = "George Tsilavina";
  direction: string = "DIRECTION ADMINISTRATIVE ET FINANCIERE";
  sevice: string = "SERVICE CENTRE MEDICO-SOCIALE";
  mode_question: number;
  contenu: string = "Mandray olona ve Dr Imisa amin'i tolak'andro Azafady"
  id_agent_actuel: any;
  message: Message = new Message(null);
  reponse: Reponse = new Reponse(null);

  id2: any;
  code: string = "ABCDEFghojklm123456789";
  infoAgentActuel: any;
  id_agent_cms_actuel: any;
  id_mess_actuel: any;

  constructor(public activatedRoute: ActivatedRoute, private router: Router, public adminService: AdminService, private cMSService: CMSService) {
    this.id_agent_cms_actuel = this.adminService.getUserIMIscrit();
    this.id = activatedRoute.snapshot.params['id'];
    this.id2 = activatedRoute.snapshot.params['id2'];
    if (this.id == 1) {
      this.mode_question = 1;
      this.GetReponseQuestionbyIdmessage();

    } else {
      this.mode_question = 2;
    }
  }
  ngOnInit() {
    this.GetQuestionbyIdmessage();
  }

  //get reponse
  GetReponseQuestionbyIdmessage() {
    this.cMSService.getListeQuestiobyIdmessacleetranger(this.id2)
      .subscribe(data => {
        this.reponse = data

      }, err => {
        console.log(JSON.parse(err._body).message);
      })
  }


  //get question by id
  GetQuestionbyIdmessage() {
    this.cMSService.getListeQuestiobyId(this.id2)
      .subscribe(data => {
        this.message = data
        this.id_mess_actuel = this.message.id_mess;
        let x = this.message.im_dest.split(" ");
        console.log(x);
        console.log(x.length);
        if (x.length == 1) {
          this.id_agent_actuel = this.message.im_dest
          this.listeWSDrh2();
        } else {
          let x = this.message.im_dest.split(" ");
          let y = x[0]
          let z = x[1]
          let w = x[2]
          let v = x[3]
          let s = y + z + w + v
          console.log(s);
          console.log("mande rohy............" + s);
          this.adminService.getlisteWSDrh2(s, this.code)
            .subscribe(data => {
              this.infoAgentActuel = data
            }, err => {
              console.log(err);
            });
        }
      }, err => {
        console.log(JSON.parse(err._body).message);
      })
  }

  //get info agent
  listeWSDrh2() {
    this.adminService.getlisteWSDrh2(this.id_agent_actuel, this.code)
      .subscribe(data => {
        this.infoAgentActuel = data
      }, err => {
        console.log(err);
      });

  }





  EnvoyerRep(rep) {
    Swal.fire({
      title: 'Réponse message',
      icon: 'info',
      text: rep,
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Envoyer!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.message.etat_mess = "l";
        //propriete reponse
        this.reponse.responsable = this.id_agent_cms_actuel;
        this.reponse.etat_reponse = "A";
        this.reponse.contenu_reponse = rep;
        this.reponse.date_reponse = new Date();
        this.reponse.id_mess = this.id_mess_actuel;

        //update etat message
        this.cMSService.updateMessage(this.message)
          .subscribe(data => {
            //save reponse
            this.cMSService.saveReponseMessage(this.reponse)
              .subscribe(data => {
                success_message4.show();
                this.router.navigate(['question']);
              }, err => {

              })
          }, err => {

          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });

  }


  //autre question

  EnvoyerMessageAutre(contenu) {
    this.message.contenue_mess = contenu

    if (this.message.contenue_mess == "" || this.message.contenue_mess == null) {
      erreu_mes_vide.show();
    } else {
      Swal.fire({
        title: 'Envoi message',
        icon: 'info',
        text: this.message.contenue_mess,
        showCancelButton: true,
        confirmButtonText: 'Oui, Envoyer!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          this.message.im_dest = this.id_agent_cms_actuel;
          this.message.date_mess = new Date();
          //{{date_clic | date: 'dd MMM yyyy hh:mm a'}}
          this.message.etat_mess = "c"
          this.cMSService.saveMessage(this.message)
            .subscribe(data => {
              success_message4.show();

              this.router.navigate(['questions']);
            }, err => {
              // console.log(JSON.parse(err._body).message);

            })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          //cancel btn
        }
      });
    }







  }



}
